import { render, staticRenderFns } from "./CorrelationList.vue?vue&type=template&id=5f9e4412&scoped=true"
import script from "./CorrelationList.vue?vue&type=script&lang=ts"
export * from "./CorrelationList.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationList.vue?vue&type=style&index=0&id=5f9e4412&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e4412",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9e4412')) {
      api.createRecord('5f9e4412', component.options)
    } else {
      api.reload('5f9e4412', component.options)
    }
    module.hot.accept("./CorrelationList.vue?vue&type=template&id=5f9e4412&scoped=true", function () {
      api.rerender('5f9e4412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CorrelationList.vue"
export default component.exports